import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  layers: [],
  sensors: [],
  poi: []
}

const mutations = {

  loadSensors (state, sensors) {
    state.sensors = sensors
  },

  loadLayers (state, layers) {
    state.layers = layers.slice(0)
  },

  loadPoi (state, poi) {
    state.poi = poi
  }
}

const getters = {

  getSensors: (state) => state.sensors,

  getLayers: (state) => state.layers,

  getPoi: (state) => state.poi

}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js